import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from './actions';
import mailActions from '../mail/actions';
import tenantActions from '../tenants/actions';
import SuperFetch from '../../helpers/superFetch';
import { apiUrls } from '../../settings';

// DO_GET_NOTIFICATIONS
const doGetNotifications = async () => {
  return await SuperFetch.post(apiUrls.getNotifications)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* getNotifications() {
  const response = yield call(doGetNotifications);
  if (response && !response.error) {
    yield put(actions.doGetNotificationsSucceeded(response));
  }
}

// DO_LOAD_ACTIONED
const doLoadActioned = async (offset) => {
  const body = {
    data: {
      offset
    }
  }
  return await SuperFetch.post(apiUrls.loadActioned, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* loadActioned({ payload }) {
  const response = yield call(doLoadActioned, payload.offset);
  if (response && !response.error) {
    yield put(actions.doLoadActionedSucceeded(response));
  }
}

// DO_LOAD_UNACTIONED
const doLoadUnactioned = async (offset) => {
  const body = {
    data: {
      offset
    }
  }
  return await SuperFetch.post(apiUrls.loadUnactioned, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* loadUnactioned({ payload }) {
  const response = yield call(doLoadUnactioned, payload.offset);
  if (response && !response.error) {
    yield put(actions.doLoadUnactionedSucceeded(response));
  }
}

// DO_SEE_ALL_NOTIFICATIONS
const doSeeAllNotifications = async () => {
  return await SuperFetch.post(apiUrls.seeAllNotifications)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* seeAllNotifications() {
  const response = yield call(doSeeAllNotifications);
  if (response && !response.error) {
    yield put(actions.doSeeAllNotificationsSucceeded(response));
  }
}

// ACTION_MESSAGE
const doActionMessage = async(threadId, bucket) => {
  const body = {
    data: { threadId, bucket }
  }
  return await SuperFetch.post(apiUrls.actionMessageNotification, body)
    .then(res => res)
    .catch(error => ({ error: JSON.stringify(error) }));
}
function* actionMessage({ payload }) {
  const response = yield call(doActionMessage, payload.threadId, payload.bucket);
  if (response && !response.error) {
    yield put(actions.doGetNotifications());
    yield put(actions.doGetCompulsoryNotifications(0));
  }
}

// GET_COMPULSORY_NOTIFICATIONS
const doGetCompulsoryNotifications = async(offset) => {
  const body = {
    data: {
      offset
    }
  }
  return await SuperFetch.post(apiUrls.getCompulsoryNotifications, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* getCompulsoryNotifications({ payload }) {
  const response = yield call(doGetCompulsoryNotifications, payload.offset);
  if (response && !response.error) {
    yield put(actions.doGetCompulsoryNotificationsSucceeded(response));
  }
}

// LOAD_COMPULSORY_NOTIFICATIONS
const doLoadCompulsoryNotifications = async(offset) => {
  const body = {
    data: {
      offset
    }
  }
  return await SuperFetch.post(apiUrls.getCompulsoryNotifications, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* loadCompulsoryNotifications({ payload }) {
  const response = yield call(doLoadCompulsoryNotifications, payload.offset);
  if (response && !response.error) {
    yield put(actions.doLoadCompulsoryNotificationsSucceeded(response));
  }
}

// ACTION_AST_NOTIFICATION
const doActionAstNotification = async(hash) => {
  const body = {
    data: { hash }
  }
  return await SuperFetch.post(apiUrls.actionAstNotification, body)
    .then(res => res)
    .catch(error => ({ error: JSON.stringify(error) }));
}
function* actionAstNotification({ payload }) {
  const response = yield call(doActionAstNotification, payload);
  if (response && !response.error) {
    yield put(actions.doGetNotifications());
    yield put(actions.doGetCompulsoryNotifications(0));
  }
}

// ACTION_REFERENCE
const doActionReference = async payload => {
  const body = {
    data: { hash: payload.data.hash, type: payload.data.type }
  }
  return await SuperFetch.post(apiUrls.actionReferenceNotification, body)
    .then(res => res)
    .catch(error => ({ error: JSON.stringify(error) }));
}
function* actionReference(payload) {
  const response = yield call(doActionReference, payload.payload);
  if (response && !response.error) {
    yield put(actions.doGetNotifications());
    yield put(actions.doGetCompulsoryNotifications(0));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.DO_GET_NOTIFICATIONS, getNotifications),
    takeEvery(actions.DO_LOAD_ACTIONED, loadActioned),
    takeEvery(actions.DO_LOAD_UNACTIONED, loadUnactioned),
    takeEvery(actions.DO_SEE_ALL_NOTIFICATIONS, seeAllNotifications),
    takeEvery(mailActions.DO_MARK_THREAD_READ, actionMessage),
    takeEvery(actions.DO_GET_COMPULSORY_NOTIFICATIONS, getCompulsoryNotifications),
    takeEvery(actions.DO_LOAD_COMPULSORY_NOTIFICATIONS, loadCompulsoryNotifications),
    takeEvery(actions.DO_ACTION_AST_NOTIFICATION, actionAstNotification),
    takeEvery(tenantActions.DO_UPDATE_TENANT_REQUEST_REFERENCE, actionReference),
  ]);
}


// WEBPACK FOOTER //
// ./src/redux/notifications/sagas.js